<section id="aboutme">
  <div class="container">
    <div class="row">
      <div class="about">
        <div class="about__title">
          <h2 class="about__title--h2">About Me</h2>
        </div>
        <div class="about__content">
          <div class="about__content--img">
            <img
              src="assets/img/perfilPro.jpg"
              alt="profile image"
              class="mx-auto"
            />
            <div class="redes">
              <a href="" class="social-icon">
                <img
                  src="../../../assets/img/iconLinkedin.svg"
                  alt="linkedin icon"
                  class="social-icon__img"
                />
              </a>
              <a href="" class="social-icon">
                <img
                  src="../../../assets/img/iconTwitter.svg"
                  alt="twiiter icon"
                  class="social-icon__img"
                />
              </a>
              <a href="" class="social-icon">
                <img
                  src="../../../assets/img/Iconinstagram.svg"
                  alt="instagram icon"
                  class="social-icon__img"
                />
              </a>
              <a href="" class="social-icon">
                <img
                  src="../../../assets/img/iconGithub.svg"
                  alt="github icon"
                  class="social-icon__img"
                />
              </a>
              <a href="" class="social-icon">
                <img
                  src="../../../assets/img/iconGitlab.svg"
                  alt="gitlab icon"
                  class="social-icon__img"
                />
              </a>
            </div>
            <button class="btn-download">Download CV</button>
          </div>
          <div class="about__content--text">
            <p class="about__content--p">
              I am a web developer with a special interest in design. I am a
              systems engineer in training and my educational and professional
              career began as a systems technician, software development
              technologist, I longed to continue scaling. I am in constant
              search of learning, I am passionate about learning new skills.
            </p>

            <details>
              <summary class="about__content--summary">Certifications</summary>
              <table class="about__content--table">
                <tr class="about__content--table--tr">
                  <td class="certifications__name">Alfreds Futterkiste</td>
                  <td class="certifications__button">Download</td>
                </tr>
              </table>
            </details>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
